/* =========================================================
   HAIR+ CAP LANDING — shared page behaviour
   - Tracking: clicks on [data-hc-track] push `hair_cap_lp_<name>` to dataLayer.
   - Reveal: [data-hc-reveal] gets .is-in once it is 25% on screen (one time).
     Only the page's few deliberate motion moments use it; CSS decides what moves.
   - Sticky bar: shows once [data-hc-dock-anchor] (the hero buy area) has scrolled away,
     hides from the first [data-hc-hide-dock] band to the end of the page, and sits
     above the cookie-consent bar when that bar is showing.
   - Re-runs on shopify:section:load (theme editor) without double-binding.
   Section-specific interactions (tabs, hotspots, mode switch) live in each section's
   own small inline script and use the custom events below where useful.
   ========================================================= */
(function () {
  if (window.__hcLanding) return;
  window.__hcLanding = true;

  function track(name, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'hair_cap_lp_' + name }, detail || {}));
    } catch (e) {}
  }
  window.hcTrack = track;

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-hc-track]');
    if (!el) return;
    track(el.getAttribute('data-hc-track') || 'click', { placement: el.getAttribute('data-hc-placement') || '' });
  });

  /* ---------- reveal ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  function bindReveal(root) {
    var els = (root || document).querySelectorAll('[data-hc-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          en.target.dispatchEvent(new CustomEvent('hc:in', { bubbles: true }));
          io.unobserve(en.target);
        });
      }, { threshold: 0.25 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- sticky bar ---------- */
  var COVERS = '#cb-cookie_consent .cb-cookie_consent-container';
  var lastOffset = -1;
  function syncOffset() {
    var vh = window.innerHeight, offset = 0;
    document.querySelectorAll(COVERS).forEach(function (el) {
      if (!el.offsetHeight || getComputedStyle(el).visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > vh - 4) offset = Math.max(offset, Math.round(vh - r.top));
    });
    if (offset === lastOffset) return;
    lastOffset = offset;
    document.documentElement.style.setProperty('--hc-dock-offset', offset + 'px');
  }
  function updateDock() {
    var dock = document.querySelector('[data-hc-dock]');
    var anchor = document.querySelector('[data-hc-dock-anchor]');
    if (!dock || !anchor) return;
    syncOffset();
    var vh = window.innerHeight;
    // show the bar once the buy area has scrolled away, and also while the hero button is still
    // below the first screen (short phones), so a buy button is always in reach
    var btn = anchor.querySelector('button') || anchor;
    var show = anchor.getBoundingClientRect().bottom < 0 || btn.getBoundingClientRect().bottom > vh;
    var stops = document.querySelectorAll('[data-hc-hide-dock]');
    stops.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) show = false;
    });
    if (!stops.length) {
      var doc = document.documentElement;
      if (window.scrollY + vh >= doc.scrollHeight - vh * 0.6) show = false;
    }
    dock.classList.toggle('is-visible', show);
    var heroZone = window.innerWidth < 750 && anchor.getBoundingClientRect().bottom > 0;
    document.documentElement.classList.toggle('hc-hero-zone', heroZone);
    document.documentElement.classList.toggle('hc-dock-open', show);
    dock.setAttribute('aria-hidden', show ? 'false' : 'true');
    dock.querySelectorAll('a, button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
  }
  var ticking = false;
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; updateDock(); }); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  setInterval(syncOffset, 700);

  /* ---------- FAQ tracking ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('.hc details[data-hc-faq]') && d.open) {
      track('faq_open', { q: ((d.querySelector('summary') || {}).textContent || '').trim() });
    }
  }, true);

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.tagName === 'DETAILS') el.open = true;
  });
  document.addEventListener('shopify:section:load', function (e) {
    bindReveal(e.target);
    updateDock();
    bindSee();
  });

  /* ---------- hero proof buttons + pop-up add to cart ----------
     [data-hc-see-ugc]  opens the Creators section's player on the first video
     [data-hc-see-ba]   opens the hero's before/after dialog (photos copied from the Results section)
     [data-hc-atc]      in a pop-up: closes it and submits the hero product form (same cart flow) */
  function heroAtc() { return document.querySelector('[data-hc-hero-atc]'); }
  function closeDialogs() {
    document.querySelectorAll('dialog[open]').forEach(function (d) { d.close(); });
  }
  function setCount(btn, n) {
    var sub = btn.querySelector('[data-hc-see-count]');
    if (sub) sub.textContent = sub.getAttribute('data-hc-see-count').replace('[count]', n);
  }
  function thumb(src, w, alt) {
    var i = document.createElement('img');
    i.src = src; i.alt = alt || ''; i.loading = 'lazy'; i.decoding = 'async'; if (w) i.width = w;
    return i;
  }
  function bindSee() {
    var see = document.querySelector('[data-hc-see]');
    var cards = document.querySelectorAll('[data-hc-ugc-open]');
    var results = document.querySelectorAll('.hc-results__item figure');
    if (see && !see.hasAttribute('data-bound')) {
      see.setAttribute('data-bound', '');
      var u = see.querySelector('[data-hc-see-ugc]');
      if (u) {
        if (!cards.length) u.hidden = true;
        else {
          var box = u.querySelector('[data-hc-see-ugc-thumbs]');
          Array.prototype.slice.call(cards, 0, 3).forEach(function (c) {
            if (c.getAttribute('data-poster')) box.appendChild(thumb(c.getAttribute('data-poster'), 30, c.getAttribute('data-name') || ''));
          });
          setCount(u, cards.length);
        }
      }
      var b = see.querySelector('[data-hc-see-ba]');
      if (b) {
        if (!results.length) b.hidden = true;
        else {
          var img = results[0].querySelector('img');
          if (img) b.querySelector('[data-hc-see-ba-thumbs]').appendChild(thumb(img.currentSrc || img.src, 56, img.alt));
          setCount(b, results.length);
        }
      }
      if ((!u || u.hidden) && (!b || b.hidden)) see.hidden = true;
      // a short, clean name for each button (the thumbnails are previews only)
      [u, b].forEach(function (btn) {
        if (!btn) return;
        var t = btn.querySelector('.hc-see__title'), s = btn.querySelector('.hc-see__sub');
        btn.setAttribute('aria-label', [(t && t.textContent) || '', (s && s.textContent) || ''].join(', ').trim());
      });
    }
    // before/after dialog gallery
    var ba = document.querySelector('[data-hc-ba]');
    if (ba && !ba.hasAttribute('data-bound')) {
      ba.setAttribute('data-bound', '');
      var g = ba.querySelector('[data-hc-ba-gallery]');
      results.forEach(function (f) {
        var c = f.cloneNode(true);
        c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        var im = c.querySelector('img');
        if (im) { im.loading = 'lazy'; im.sizes = '(min-width: 750px) 300px, 92vw'; }
        var r = parseFloat(f.parentElement && f.parentElement.style.getPropertyValue('--r'));
        if (r) c.style.setProperty('--r', r);
        g.appendChild(c);
      });
      ba.querySelector('[data-hc-ba-close]').addEventListener('click', function () { ba.close(); });
      ba.addEventListener('click', function (e) { if (e.target === ba) ba.close(); });
      ba.addEventListener('close', function () {
        document.documentElement.classList.remove('hc-ba-open');
        if (ba.__opener) ba.__opener.focus({ preventScroll: true });
      });
    }
    // pop-up add-to-cart buttons: label + price from the hero button; hidden without a hero form
    var h = heroAtc();
    document.querySelectorAll('[data-hc-atc-wrap]').forEach(function (w) {
      w.hidden = !h;
      var player = w.closest('.hc-ugc__player');
      if (player) player.classList.toggle('is-buy', !!h);
    });
    if (h) {
      document.querySelectorAll('[data-hc-atc-price]').forEach(function (a) {
        var price = h.getAttribute('data-hc-price');
        a.textContent = h.textContent.trim() + (price ? ' · ' + price : '');
        a.disabled = h.disabled;
      });
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-hc-see-ugc], [data-hc-see-ba], [data-hc-atc]');
    if (!t) return;
    var placement = t.getAttribute('data-hc-placement') || '';
    if (t.hasAttribute('data-hc-see-ugc')) {
      var card = document.querySelector('[data-hc-ugc-open]');
      if (!card) return;
      closeDialogs();
      track('ugc_open', { placement: placement });
      card.click();
    } else if (t.hasAttribute('data-hc-see-ba')) {
      var ba = document.querySelector('[data-hc-ba]');
      if (!ba || typeof ba.showModal !== 'function') {
        var r = document.querySelector('.hc-results');
        if (r) r.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      ba.__opener = t;
      document.documentElement.classList.add('hc-ba-open');
      ba.showModal();
      ba.querySelector('[data-hc-ba-close]').focus({ preventScroll: true });
      track('ba_open', { placement: placement });
    } else {
      var h = heroAtc();
      if (!h || h.disabled) return;
      closeDialogs();
      track('add_to_cart', { placement: placement });
      var f = h.form;
      if (f && typeof f.requestSubmit === 'function') f.requestSubmit(h);
      else h.click();
    }
  });

  function init() { bindReveal(document); updateDock(); bindSee(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
